<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {defineProps} from "vue";

const props = defineProps({
    authView: {
        type: Boolean,
        default: false
    }
});

const portalContentAndDesignStore =  usePortalContentAndDesignStore()
</script>

<template>
    <radio-group-inline
        label="Layout"
        name="portal_layout"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout = $event"
        :options="[
            { value: 'one', label: 'Modern'},
            { value: 'two', label: 'Casual'},
            { value: 'three', label: 'Sidebar'},
        ]"
    >
    </radio-group-inline>

    <radio-group-inline
        label="Layout style"
        name="portal_layout_layout_style"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_style"
        :options="[
            { value: 'border', label: 'Border'},
            { value: 'shadow', label: 'Shadow'},
            { value: 'bald', label: 'Bald'},
            { value: 'none', label: 'None'}
        ]"
    >
    </radio-group-inline>

    <radio-group-inline-color
        label="Layout corners"
        name="portal_layout_layout_corners"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_corners"
        @picked="portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_corners = $event.finalValue"
        :options="[
            { value: 'none', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyLjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHkiIHg9IjE0IiB5PSI0NiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48L3JlY3Q+IDwvZz4gPC9nPiA8L3N2Zz4=', label_is_img: true},
            { value: 'rounded', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU1LjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSI1NyIgeT0iNDYiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjQiPjwvcmVjdD4gPC9nPiA8L2c+IDwvc3ZnPg==', label_is_img: true},
            { value: 'rounded-lg', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTk4LjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHktMiIgeD0iMTAwIiB5PSI0NiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iOCI+PC9yZWN0PiA8L2c+IDwvZz4gPC9zdmc+', label_is_img: true},
        ]"
    >
    </radio-group-inline-color>

    <radio-group-inline
        label="Icons"
        name="portal_layout_icons"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_icons"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_icons = $event"
        :options="[
            { value: 'outline', label: 'Outline'},
            { value: 'bold', label: 'Bold'},
            { value: 'off', label: 'None'},
        ]"
    >
    </radio-group-inline>

    <radio-group-inline
        label="Logo size"
        name="portal_layout_logo_size"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_logo_size"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_logo_size = $event"
        :options="[
            { value: 'max-h-4', label: 'Small'},
            { value: 'max-h-6', label: 'Default'},
            { value: 'max-h-8', label: 'Medium'},
            { value: 'max-h-10', label: 'Large'},
        ]"
    >
    </radio-group-inline>
</template>
